module.exports = __webpack_public_path__ + "static/award_logo-c93340ebe2cbc1505369547a091ad227.png";